const u = {};
//=require base.js
//=require storage.js
//=require consumer.js
//=require bind.js
//=require for.js
//=require toggle.js
//=require carousel.js
//=require carousel-nav.js
//=require carousel-move.js
//=require carousel-swipe.js
//=require openable.js
//=require autocomplete.js
//=require autocomplete-option.js
//=require tabs.js
//=require tab-select.js
//=require menu.js
//=require toggle-hover.js
//=require modal-form.js